import { render } from "./P021.vue?vue&type=template&id=d68d8538&scoped=true"
import script from "./P021.vue?vue&type=script&lang=js"
export * from "./P021.vue?vue&type=script&lang=js"

import "./P021.vue?vue&type=style&index=0&id=d68d8538&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d68d8538"]])

export default __exports__